/**
 * [FreiholtzK:Tue/15-12-2020] @todo look into making this into a more generic warnign system for all generators if applicable.
 */
export enum EGeneratorNuclearWarning {
  GNW_None,
  GNW_WasteFull,
  GNW_MissmatchBetweenInputAndWaste,
}
